import * as React from 'react';
import { useState } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { loginAction } from '../../actions/loginAction';
import FrontDetail from './frontDetail';
import FrontLogin from './frontLogin';
import { getAuthData } from '../../services/selectors/Accounts';

interface IFrontProps {
	dispatch: Dispatch<any>;
	loginData: any;
}

const FronApp: React.SFC<IFrontProps> = ({ dispatch, loginData }) => {

	const urlParams = new URLSearchParams(window.location.search);
	const frontToken = urlParams.get("auth_secret");

	const token = frontToken ? frontToken : null;

	const [isAuthed, setIsAuthed] = useState(false);
	const [isLoggedIn, setIsLoggedIn] = useState(false);

	const isTest = sessionStorage.getItem('isTest');
	const authData = getAuthData();

	React.useEffect(() => {		
		if ((token != null || isTest) && !isAuthed) {
			dispatch(loginAction.frontAppCheckToken(token));
		}

		if (authData && !isLoggedIn) {
			setIsLoggedIn(true);
			sessionStorage.setItem("frontLogged", 'true')
		}
	}, [token])

	if (loginData) {
		if (loginData.isSuccess && loginData.isValidToken && !isAuthed) {
			loginData.isValidToken = false;
			loginData.isSuccess = false;
			setIsAuthed(true);
		}
	}

	const handleCallback = (val) => {
		setIsLoggedIn(val);
		sessionStorage.setItem("frontLogged", 'true')
	}

	return (
		<div className="App frontApp">
			{isAuthed ?
				<div className="App frontApp">
					{isLoggedIn ?<FrontDetail />:<FrontLogin callback={handleCallback} />}
				</div> :
				<div className="access-denied">
					<h5>This page will be loaded within frontapp...</h5>
				</div>
			}
		</div>
	);
}

const mapStateToProps = (state: any) => {
	const { loginData } = state;
	return { loginData };
};

export default connect(mapStateToProps)(FronApp);